export enum CUSTOMIZATION_TAB_ID {
  LOGO = 'logo',
  BANNER = 'banner',
}

export enum CUSTOMIZATION_ENTITY_TYPE {
  COMPANY_GROUP = 'company-group',
  BROKER = 'broker',
}

export enum APP_CUSTOMIZABLE_ITEM_KEY {
  LOGO = 'logo',
  BANNER = 'banner',
  BUTTON_BANNER = 'buttonBanner',
}

export enum UI_COMPONENT_TYPE {
  BUTTON_BANNER = 'button_banner',
}
